<template>
  <div class="app">
    <RmHeader />
    <GlobalComponents />
    <div
      v-if="isShowCategoriesMenu"
      class="is-shadow"
    />
    <div class="content w-full max-w-screen-xl mx-auto">
      <NuxtPage />
    </div>
    <RmFooter />
  </div>
</template>

<script setup>
import RmFooter from '~/components/footer/index.vue'
import RmHeader from '~/components/header/index.vue'
import GlobalComponents from '~/components/layout/global_components.vue'

const isShowCategoriesMenu = useGlobal().isShowCategoriesMenu
</script>
